var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.thirdPartyTagsData)?_c('div',[(_vm.thirdPartyTagsData.freshchat)?_c('fresh-chat-widget'):(_vm.thirdPartyTagsData.intercom)?_c('intercom-widget'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }